import { AxiosError, AxiosResponse } from "axios";
import {
  IErrorResponse,
  ISuccessResponse,
} from "../service/interfaces/ApiResponse.interface";
import toast from "react-hot-toast";

export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const MASTER_URL = process.env.REACT_APP_MASTER_URL;
export const OPERTIONS_URL = process.env.REACT_APP_OPERTIONAL_URL; //6048
export const AUTH_URL = process.env.REACT_APP_AUTH_URL;
export const ECHO_URL = process.env.REACT_APP_ECHO_URL;


export const STATUS = {
  SUCCESS: "success",
  FAILURE: "failure",
};

export const parseAxiosError = (error: AxiosError) => {
  try {
    if (error.isAxiosError && error.response) {
      const { status, data } = error.response;

      // Handle cases where data might be undefined or not a valid object
      let errorMessage = "Something went wrong. Please try again later.";

      if (data && typeof data === 'object') {
        const responseData = data as IErrorResponse;
        errorMessage = responseData.message || errorMessage;
      } else if (typeof data === 'string') {
        errorMessage = data;
      } else if (data === undefined || data === null) {
        errorMessage = `Server error (${status}). Please try again later.`;
      }

      console.error("parseAxiosError:", { status, data, errorMessage });

      if (status === 401) {
        toast.error(` ${errorMessage}`);
      }
      else if (status === 403) {
        toast.error(` ${errorMessage}`);
      } else if (status === 404) {
        toast.error(`${errorMessage}`);
      }
      else if (status === 500) {
        toast.error(` ${errorMessage}`);
      } else if (status === 503) {
        toast.error(` ${errorMessage}`);
      } else if (status === 504) {
        toast.error(` ${errorMessage}`);
      } else {
        toast.error(` ${errorMessage}`);
      }

      return { status: STATUS.FAILURE, message: errorMessage, error };
    } else if (error.request) {
      console.error(
        "API request made, but no response received:",
        error.request
      );
      toast(
        ` No response received from the server. Please try again later.`
      );
      return { status: STATUS.FAILURE, message: error.message, error };
    } else {
      if (error.code !== "ERR_CANCELED") {
        toast.error(` ${error.message}`);
      }

      return { status: STATUS.FAILURE, message: error.message, error };
    }
  } catch (e: any) {
    console.log("parseAxiosError:", e.message);
    return { status: STATUS.FAILURE, message: e.message, error };
  }
};


export const parseAxiosSuccess = (response: ISuccessResponse) => {
  try {
    // console.log("parseAxiosSuccess : " + response);
    if (response && response.status === "200") {
      toast.success(response.message || "Operation completed successfully");
    } else if (response && response.message) {
      toast.error(response.message);
    } else {
      console.warn("Invalid success response:", response);
    }
    // return { status: STATUS.SUCCESS, data: response.data, response };
  } catch (e: any) {
    console.log("parseAxiosSuccess" + e.message);
    return { status: STATUS.FAILURE, message: e.message, error: e };
  }
};
